import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../default-cloud-graph-document-entity-ati';
import { TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { ForgeUtoolityGitbookIcon } from './icon';
import { ForgeUtoolityGitbookSearchResultIcon } from './search-result-icon';

export const forgeUtoolityGitbookConfig: ThirdPartyConfig = {
	displayName: 'Gitbook - by Utoolity',
	id: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
	resourceType: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
	icon: get3PLogo(ForgeUtoolityGitbookIcon, 'ForgeUtoolityGitbook', 'medium'),
	searchResultIcon: get3PLogo(
		ForgeUtoolityGitbookSearchResultIcon,
		'ForgeUtoolityGitbook',
		'large',
	),
	integrationAri: 'ari:cloud:platform::integration/byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	filters: ['lastUpdated'],
	requiresOauth: false,
	isEnabled: () => true,
	displayWorkspaceNameAsProductName: true,
};
